import { Component, inject } from '@angular/core';
import { WorkspaceStore } from '../../../stores/workspace/workspace.state';
import { ButtonModule } from 'primeng/button';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { MenuItem, MessageService } from 'primeng/api';
import { asWorkspaceTypeKey, Workspace } from '../../../models/workspace';
import { TabViewModule } from 'primeng/tabview';
import { ActivatedRoute, Router } from '@angular/router';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from '../../atoms/header/header.component';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { ToastModule } from 'primeng/toast';
import { BaseListComponent } from '../base-list/base-list.component';
import { TableCaptionComponent } from '../../molecules/table-list-caption/table-list-caption.component';
import { TableListActionsComponent } from '../../molecules/table-list-actions/table-list-actions.component';
import { MaskComponent } from '../mask/mask.component';
import { RoutingService } from '../../../services/routing.service';

@Component({
  selector: 'app-workspace-list',
  standalone: true,
  imports: [
    ButtonModule,
    NgForOf,
    NgIf,
    TabViewModule,
    TabMenuModule,
    TableModule,
    InputTextModule,
    SidebarModule,
    AsyncPipe,
    FormsModule,
    HeaderComponent,
    ToastModule,
    TableCaptionComponent,
    TableCaptionComponent,
    TableListActionsComponent,
    MaskComponent,
  ],
  templateUrl: './workspace-list.component.html',
  styleUrl: './workspace-list.component.scss',
})
export class WorkspaceListComponent extends BaseListComponent<Workspace> {
  readonly store = inject(WorkspaceStore);
  override sidebarId = 'workspace-administration';
  override menuItems: MenuItem[] = [];

  constructor(
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );
    this.initializeMenuItems();
  }

  /**
   * Initializes the menu items for the application. The method sets up an array of menu item objects,
   * each containing properties such as label, icon, id, and routerLink for specific navigation functionality.
   *
   * @return {void} No value is returned as this method only initializes the menuItems property.
   */
  initializeMenuItems(): void {
    this.menuItems = [
      {
        label: 'Indikatorenordner',
        icon: 'fas fa-folder',
        id: 'indicatorCategory',
        routerLink: ['../indikatoren-bereiche'],
      },
      {
        label: 'Räume',
        icon: 'fa-regular fa-map',
        id: 'dataLayerType',
        routerLink: ['../räume'],
      },
      {
        label: 'Standorte',
        icon: 'fas fa-location-dot',
        id: 'poiDataLayerType',
        routerLink: ['../poi'],
      },
      {
        label: 'Themenbereiche',
        icon: 'fas fa-layer-group',
        id: 'bookmarkCategory',
        routerLink: ['../lesezeichen-bereiche'],
      },
      {
        label: 'Themen',
        icon: 'fas fa-book-open',
        id: 'topic',
        routerLink: ['../themen'],
      },
    ];
  }

  protected readonly asWorkspaceTypeKey = asWorkspaceTypeKey;
}
